import { FunctionComponent, ReactNode } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper';
import CanPower from '../canPower';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { createEFPic } from '@/utils/useEFPic';
import EFLight from '@/components/UI/svg/LandingPage/EFLight';
import EFWifiRouter from '@/components/UI/svg/LandingPage/EFWifiRouter';
import EFPhone from '@/components/UI/svg/LandingPage/EFPhone';
import EFLaptop from '@/components/UI/svg/LandingPage/EFLaptop';
import EFRefrigerator from '@/components/UI/svg/LandingPage/EFRefrigerator';
import EFElectricHeater from '@/components/UI/svg/LandingPage/EFElectricHeater';
import EFMicroware from '@/components/UI/svg/LandingPage/EFMicroware';
import EFElectricKettle from '@/components/UI/svg/LandingPage/EFElectricKettle';
import EFCoffeeMaker from '@/components/UI/svg/LandingPage/EFCoffeeMaker';
import EFAirConditioner from '@/components/UI/svg/LandingPage/EFAirConditioner';

const { EFPic } = createEFPic('/img/landingPage/');
interface PropsType {
    id: string;
}
const LINK_MAP: any = {
    za: 'https://za.ecoflow.com/products/river-pro-portable-power-station',
    // au: 'https://au.ecoflow.com/collections/ecoflow-river-series/products/river-2-pro-portable-power-station',
    sa: 'https://www.amazon.ae/EF-ECOFLOW-Portable-Charging-Generator/dp/B0CC5PKRFQ/ref=sr_1_4?crid=1CS0UMRJ02XTQ&keywords=river+2+pro&qid=1690946106&sprefix=river+2+p%27ro%2Caps%2C269&sr=8-4',
};

const River2ProKit: FunctionComponent<PropsType> = (props) => {
    const { useLang, gtm, useRouter } = useGlobal();
    const { t } = useLang('landingPage');
    const { locale } = useRouter();

    const canPowerList = [
        {
            name: t('secF_Light'),
            times: `20 ${t('secF_hrs')}`,
            icon: <EFLight />,
        },
        {
            name: t('secF_WiFiRouter'),
            times: `23 ${t('secF_hrs')}`,
            icon: <EFWifiRouter />,
        },
        {
            name: t('secF_phone'),
            times: `67 ${t('secF_times')}`,
            icon: <EFPhone />,
        },
        {
            name: t('secF_laptop'),
            times: `12 ${t('secF_times')}`,
            icon: <EFLaptop />,
        },
        {
            name: t('secF_Refrigerator'),
            times: `5-10 ${t('secF_hrs')}`,
            icon: <EFRefrigerator />,
        },
        {
            name: t('secF_ElectricHeater'),
            times: `0.3 ${t('secF_hrs')}`,
            icon: <EFElectricHeater />,
        },
        {
            name: t('secF_Microwave'),
            times: `50 ${t('secF_min')}`,
            icon: <EFMicroware />,
        },
        {
            name: t('secF_ElectricKettle'),
            times: `50 ${t('secF_min')}`,
            icon: <EFElectricKettle />,
        },
        {
            name: t('secF_CoffeeMaker'),
            times: `0.7 ${t('secF_hrs')}`,
            icon: <EFCoffeeMaker />,
        },
        {
            name: t('secF_AirConditioner'),
            times: `0.4-0.8 ${t('secF_hrs')}`,
            icon: <EFAirConditioner />,
        },
    ];

    const buyNow = () => {
        try {
            // GA埋点
            gtm.push({
                event: 'uaEvent',
                event_name: 'buy',
                product_name: t('ts_bundle_river2_pro_2'),
                position: `Solution Page_${t('ts_bundle_river2_pro_1')}`,
            });
            // fb埋点
            window?.fbq && window?.fbq('track', 'Search');
        } catch (e) {
            console.log(e);
        }
        window.open(LINK_MAP[locale]);
    };

    return (
        <div className={css.river2ProKit} id={props.id}>
            <div className="content">
                <div className="swiper">
                    <Swiper
                        modules={[Autoplay, Pagination]}
                        className="solution-swiper starterkit-swiper"
                        pagination={{
                            clickable: true,
                        }}
                        navigation={false}
                        initialSlide={0}
                        autoplay={true}
                        loop
                        speed={800}
                        spaceBetween={10}
                        centeredSlides={true}
                    >
                        <SwiperSlide>
                            <div className="img-box">
                                <EFPic
                                    name={[
                                        locale === 'za'
                                            ? 'product/bundle_river_pro_ts.webp'
                                            : locale === 'au'
                                            ? 'product/R2+TS.webp'
                                            : 'product/bundle_river2_pro_ts.webp',
                                        locale === 'za'
                                            ? 'product/bundle_river_pro_ts.png'
                                            : locale === 'au'
                                            ? 'product/R2+TS.png'
                                            : 'product/bundle_river2_pro_ts.png',
                                    ]}
                                    alt={t('ts_bundle_river2_pro_1')}
                                />
                            </div>
                        </SwiperSlide>
                        <SwiperSlide>
                            <div className="img-box">
                                <EFPic
                                    name={[
                                        locale === 'za' ? 'bundle_river_pro.webp' : 'bundle_river2_pro.webp',
                                        locale === 'za' ? 'bundle_river_pro.jpg' : 'bundle_river2_pro.jpg',
                                    ]}
                                    alt={t('ts_bundle_river2_pro_1')}
                                />
                            </div>
                        </SwiperSlide>
                    </Swiper>
                </div>
                <div className="info-box">
                    <div className="name">{t('ts_bundle_river2_pro_1')}</div>
                    <div className="device">{t('ts_bundle_river2_pro_2')}</div>
                    <div className="power">
                        {t.rich('ts_bundle_river2_pro_3', {
                            p: (child: ReactNode) => <p>{`- ${child}`} </p>,
                        })}
                    </div>
                    <div className="desc">{t('ts_bundle_river2_pro_4')}</div>
                </div>
                {LINK_MAP[locale] && (
                    <div className="buy-box">
                        <div className="buy-btn" onClick={() => buyNow()}>
                            {locale === 'au' ? t('learn_more') : t('buy_now')}
                        </div>
                        <p className="buy-desc">{t('ts_bundle_river2_pro_tip')}</p>
                    </div>
                )}
                {locale !== 'au' && <CanPower list={canPowerList} />}
            </div>
        </div>
    );
};

export default River2ProKit;
